import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

class ChangeEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            CurrentPassword: "",
            newEmail: "",
            loading: false,
            sucess: false,
            error: "",
        }
    }

    onSubmitNewEmail = async () => {
        if (this.state.loading || this.state.sucess)
            return;

        if (this.state.newEmail === "" || this.state.CurrentPassword === "") {
            this.setState({ error: "Must fill all fields" })
            return;
        }

        try {
            this.setState({ loading: true })
            const auth = await Fire.shared.reauthenticate(this.state.CurrentPassword)
            if (auth.code === "auth/wrong-password") {
                this.setState({ error: "Your password is incorrect" })
            } else if (auth.user != null) {
                const status = await Fire.shared.changeEmail(this.state.newEmail)
                if (status.code === "auth/invalid-email") {
                    this.setState({ error: "Invalid email address" })
                } else if(status.code === "auth/email-already-in-use"){
                    this.setState({ error: "Email already in use" })
                }
                
                else if (status === "sucess") {
                   
                    this.setState({sucess: true, newEmail:"", CurrentPassword: "" })
                } else {
                    this.setState({ error: "Invalid email address" })
                }
            }
            this.setState({ loading: false})
        } catch (error) {
            Aux.handleError(error)
            this.setState({error: "An error occurred, try again", loading: false})
        }
    }

    goBack = () => {
        try{
            this.props.history.goBack()
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{width:"100%"}}>
            <section className="container">
                <div className="reversed-button-hover" style={{display:"flex", alignItems:"center",}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Change Email</h2>
                </div>

                {this.props.myDataProvider.user ? 
                    this.props.myDataProvider.user.provider !== "email" ? (
                    <div style={{ display: "flex", alignItems: "center", justifyContent:"center" }}>
                        <span style={{ marginTop: 30 }}>
                            you logged in with social media
                        </span>
                    </div>
                ) : ( 
                        <div>
                            <div style={{margin:"20px 0"}}>
                                <span style={{ color: "#777", alignSelf: "center", fontSize: 14,  }}>
                                    To change your email please fill the fields below
                                </span>
                            </div>
                            <SucessMessage isSucess={this.state.sucess}></SucessMessage>
                            <ErrorMessage text={this.state.error}></ErrorMessage>
                            
                            <TextInputMaterial type="password" placeholder="Current Password" title="Current Password"
                                value={this.state.CurrentPassword} style={{marginTop:15}}
                                onChange={(e) => {
                                    this.setState({ CurrentPassword: e.target.value, error: "" });
                                }}
                            />
                            <TextInputMaterial type="text" placeholder="New Email" title="New Email"
                                value={this.state.newEmail} style={{marginTop:15}}
                                onChange={(e) => {
                                    this.setState({ newEmail: e.target.value, error: "" });
                                }}
                            />

                            <ButtonLoader
                                text="Change Email"
                                loading={this.state.loading}
                                style={{ backgroundColor: Colors.mainColor, width: "100%", height:45, marginTop:25 }}
                                // icon={FacebookIcon}
                                onClick={this.onSubmitNewEmail}
                            ></ButtonLoader>

                        </div>
                    ) : 
                        <LoadingHelper/>
                    }

            </section>
            </div>
        );
    }
}

export default withMyDataContext(ChangeEmail);